import React, {useContext} from 'react';
import { CornerDialog } from 'evergreen-ui';

import VendasContext from '../../../../context/VendasContext';

export default function FeedBack() {

    const {
        isShowFeedBack, setIsShowFeedBack,
    } = useContext(VendasContext);

    return(
        <CornerDialog
            title="Recibo enviado!"
            isShown={isShowFeedBack}
            onCloseComplete={() => setIsShowFeedBack(false)}
            hasFooter={false}
        >
            O recibo foi enviado para o backoffice : )<br/>
            Ele não poderá mais ser editado.
        </CornerDialog>
    )
}